import React, { createContext, useContext, useState } from 'react'

import { PAGE_CONTROL_BAR_KEY } from '../constants'

class ReportPage {
  constructor ({ page, controlBarsState }) {
    const [ controlBars, setControlBars ] = controlBarsState
    this.page = page
    this.controlBars = controlBars
    this.setControlBars = setControlBars
  }

  getControlBarState (key) {
    return this.controlBars[key]
  }

  setControlBarState (key, state) {
    this.setControlBars({ ...this.controlBars, [key]: state })
  }

  getPageControlBarState () {
    return this.getControlBarState(PAGE_CONTROL_BAR_KEY)
  }

  setPageControlBarState (state) {
    return this.setControlBarState(PAGE_CONTROL_BAR_KEY, state)
  }
}

const ReportPageContext = createContext()

export const useReportPageContext = function () {
  return useContext(ReportPageContext)
}

export const ReportPageContextProvider = function ({ page, children }) {
  const controlBarsState = useState({})
  const reportPage = new ReportPage({ page, controlBarsState })

  return (
    <ReportPageContext.Provider value={reportPage}>
      {children}
    </ReportPageContext.Provider>
  )
}
